import {RouteInterfaceType} from "@twigsby/frontend-framework";
import SignUp from "../Pages/SignUp/SignUp";
import SignUpTwo from "../Pages/SignUp/SignUpTwo";
import SignUpThree from "../Pages/SignUp/SignUpThree";
import {SuggestibleRouteInterface} from "./TopRoutes";

const SignUpRoutes: Array<SuggestibleRouteInterface> = [
    {
        title: 'Sign Up',
        path: '/signup',
        element: <SignUp />,
        skipSuggestion: true
    },
    {
        title: 'Sign Up 2',
        path: '/signup2',
        element: <SignUpTwo />,
        skipSuggestion: true
    },
    {
        title: 'Sign Up 3',
        path: '/signup3',
        element: <SignUpThree />,
        skipSuggestion: true
    },
];

export default SignUpRoutes;
